import { store } from 'store';
import { getDistinctValues, titleize } from 'utils/normalizers';
import { padronesModelsEnum } from 'views/Tramites/GPM/enums';
import { ActionsNames, hasActionPermission } from '.';

// exclude lotedepanteon from padronesModels if env is not oaxaca
export const padronesModels = Object.values(padronesModelsEnum)
  .filter((p) => {
    if ((process.env.REACT_APP_ENV_NAME !== 'oaxaca' || process.env.REACT_APP_ENV_NAME !== 'navojoa' || process.env.REACT_APP_ENV_NAME !== 'tlajomulco') && p === 'lotedepanteon') return false;
    return true;
  });

export const modelsSearches = {
  ciudadano: [
    'genero',
    'estadocivil',
    'lada',
  ],
  empresa: ['tipodeestablecimiento', 'tipodeempresa'],
  vehiculo: ['estadodelvehiculo'],
  predio: ['clavedepredio', 'configuraciondeclave'],
  derivadoEmpresa: ['unidadderecaudacion'],
  infraccion: ['estadodelainfraccion'],
  contratodepolicia: ['tipodecontratodepolicia'],
  expedientemodulodemercado: ['zonademodulo'],
};

export const allModelsSearches = getDistinctValues(Object.keys(modelsSearches)
  .map((key) => modelsSearches[key]).flat());

export const hasPadronPermission = (tipoDePadron) => {
  const model = store.getState().catalogs.padrones.find((p) => p.id === tipoDePadron)?.model;
  return hasActionPermission(model, ActionsNames.view);
};

export const hasAdvanceSearchPermissions = (tipoDePadron) => {
  const model = store.getState().catalogs.padrones.find((p) => p.id === tipoDePadron)?.model;
  if (!model) return false;
  return (modelsSearches[model] || []).every((p) => hasActionPermission(p, ActionsNames.view));
};

const fksPadronesEmpresa = [
  'unidadderecaudacion',
  'empresa',
];

const titlesPadronesEmpresa = {
  juegodeazar: 'Juego de Azar',
  casadeempenio: 'Casa de Empeño',
  retenedorcedular: 'Retenedor Celular',
  retenedordenomina: 'Retenedor de Nómina',
};

const padronesEmpresa = [
  'hospedaje',
  'arrendamiento',
  'nomina',
  'alcohol',
  'cedular',
  'juegodeazar',
  'notario',
  'casadeempenio',
  'agencia',
  'retenedorcedular',
  'retenedordenomina',
  'estacionamiento',
];

export const getPermissionActionsConfigsPadrones = (action) => [
  {
    padron: 'ciudadano',
    title: 'Ciudadano',
    models: [
      'estadocivil',
      'genero',
      'lada',
      'tipodeconsiderado',
    ],
  },
  {
    padron: 'empresa',
    title: 'Empresa',
    models: [
      'lada',
      'unidadderecaudacion',
      'ciudadano',
      'contribuyente',
      'predio',
      'clasedeactividadempresarial',
      'sectorcomercial',
      'clasificaciondecomercio',
      'tipodeestablecimiento',
      'tipodeempresa',
      'claseempresarial',
    ],
  },
  {
    padron: 'predio',
    title: 'Predio',
    models: [
      'tipodepredio',
      'tipodetenencia',
      'tipodedesarrollodepredio',
      'motivodemeritodemeritoterreno',
      'usodepredio',
      'regimendepropiedad',
      'ciudadano',
      'contribuyente',
      'unidaddemedidadesuperficieparapredio',
      'unidaddemedidaparapredio',
      'condominio',
      'corredordevalor',
      'tipodecondomonio',
      'zonahomogenea',
    ],
  },
  {
    padron: 'vehiculo',
    title: 'Vehiculo',
    models: [
      'procedenciadevehiculo',
      'usodelamotocicleta',
      'clavededocumentoderegularizacion',
      'serviciodelvehiculo',
      'estadodelvehiculo',
      'tipodevehiculo',
      'clasedelvehiculo',
      'contribuyente',
      'ciudadano',
      'usuario',
      'versionvehicular',
      'tipodetenenciavehicular',
      'catalogodecolorvehicular',
      'tipodecombustiblevehicular',
      'catalogodepais',
      'lineavehicular',
    ],
  },
  ...padronesEmpresa.map((p) => ({
    padron: p,
    title: titleize(titlesPadronesEmpresa[p] || p),
    models: fksPadronesEmpresa,
  })),
  {
    padron: 'contribuyente',
    title: 'Contribuyente',
    models: [
      'tipodeidentificacion',
      'estadodelpadron',
      'tipodepersona',
      'regimencapital',
      'lada',
      'ciudadano',
      'regimenfiscal',
      'unidadderecaudacion',
    ],
  },
  {
    padron: 'motocicleta',
    title: 'Motocicleta',
    models: [
      'clavededocumentoderegularizacion',
      'tipodecombustiblevehicular',
      'catalogodepais',
      'catalogodecolorvehicular',
      'marcademotocicleta',
      'usodelamotocicleta',
      'documentoparamotocicleta',
      'serviciodelvehiculo',
      'unidadderecaudacion',
      'contribuyente',
      'ciudadano',
      'estadodelvehiculo',
    ],
  },
  {
    padron: 'remolque',
    title: 'Remolque',
    models: [
      'estadodelvehiculo',
      'catalogodepais',
      'clavededocumentoderegularizacion',
      'catalogodecolorvehicular',
      'marcaderemolque',
      'usodelremolque',
      'serviciodelvehiculo',
      'unidadderecaudacion',
      'contribuyente',
      'ciudadano',
      'tramitedelremolque',
    ],
  },
  {
    padron: 'contratodepolicia',
    title: 'Policia Especial',
    models: [
      'tipodecontratodepolicia',
      'tipodeserviciodepolicia',
      'empresa',
    ],
  },
  {
    padron: 'infraccion',
    title: 'Infracción',
    models: [
      'estadodelainfraccion',
      'tipodeinfractor',
      'contribuyente',
      'ciudadano',
      'genero',
      'permisodetipodeplaca',
      'sectordeinfraccion',
      'agentepolicial',
      'unidadpoliciaca',
      'tipodedocumentodegarantia',
    ],
  },
  {
    padron: 'expedientedecomercioinformal',
    title: 'Comercio Informal',
    models: [
      'empresa',
      'tipodecategoriadecomercioinformal',
      'catalogodedias',
      'girodecomercioinformal',
    ],
  },
  {
    padron: 'expedientedemercado',
    title: 'Mercado',
    models: [
      'empresa',
      'mercado',
      'catalogodedias',
      'girodemercado',
    ],
  },
  {
    padron: 'expedientedelicenciafuncionamiento',
    title: 'Licencia de Funcionamiento',
    models: [
      'estadodelpadron',
      'empresa',
      'girodelicencia',
      'categoriadegirodelicencia',
    ],
  },
  {
    padron: 'zonaexclusiva',
    title: 'Zona Exclusiva',
    models: [
      'empresa',
      'tipodezonaexclusiva',
    ],
  },
  {
    padron: 'expedientedeanuncio',
    title: 'Anuncios',
    models: [
      'empresa',
      'aseguradora',
    ],
  },
  {
    padron: 'multa',
    title: 'Multa',
    models: [
      'unidadresponsable',
      'unidadoperativa',
      'usuario',
      'sectordemulta',
      'tipodeobra',
      'clasedemulta',
      'estadodemulta',
      'contribuyente',
      'ciudadano',
    ],
  },
  {
    padron: 'ventadealcohol',
    title: 'Venta de Alcohol',
    models: [
      'tipodealcohol',
      'clasedeactividadempresarial',
    ],
  },
  {
    padron: 'serviciopublico',
    title: 'Servicio Público',
    models: [
      'usodelamotocicleta',
      'clavededocumentoderegularizacion',
      'serviciodelvehiculo',
      'estadodelvehiculo',
      'tipodevehiculo',
      'clasedelvehiculo',
      'contribuyente',
      'ciudadano',
      'usuario',
      'documentodetramite',
      'versionvehicular',
      'tipodetenenciavehicular',
      'catalogodecolorvehicular',
      'tipodecombustiblevehicular',
      'catalogodepais',
      'lineavehicular',
      'organizacionserviciopublico',
      'configuraciondesegmentofolio',
      'rutaserviciopublico',
      'modalidadserviciopublico',
      'sitioserviciopublico',
    ],
  },
].map((e) => ({
  name: `${action}_${e.padron}`,
  title: `${action === ActionsNames.add ? 'Agregar' : 'Cambiar'} ${e.title}`,
  permissions: [`${action}_${e.padron}`, ...e.models.map((m) => `view_${m}`)],
  action: ActionsNames.view,
}));

export const permissionSectionsPadrones = [
  {
    name: 'consulta_padrones',
    title: 'Consulta de padrones',
    models: padronesModels,
    action: ActionsNames.view,
    caja: true,
    gpm: true,
  },
  {
    name: 'alta_padrones',
    title: 'Alta de padrones',
    models: ['ciudadano', 'empresa', 'contribuyente'],
    action: ActionsNames.add,
    caja: true,
  },
  {
    name: 'edicion_padrones',
    title: 'Edición de padrones',
    models: ['ciudadano', 'empresa', 'contribuyente'],
    action: ActionsNames.change,
    caja: true,
  },
  {
    name: 'busquedas_avanzadas_padrones',
    title: 'Búsquedas avanzadas padrones',
    models: allModelsSearches,
    action: ActionsNames.view,
    caja: true,
    gpm: true,
  },
];
